import DOMPurify from 'dompurify';

// Any link that survives sanitization must open safely: no reference to the
// opener window (prevents reverse-tabnabbing) and in a new tab.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Sanitizes an untrusted HTML string before it is injected via
 * `dangerouslySetInnerHTML`. Strips `<script>`, event handlers (`on*`),
 * `javascript:` URLs, etc. Use this for any HTML that originates from the
 * server or from user/third-party input (email bodies, server-rendered
 * templates, …).
 *
 * @param {string} dirty - The untrusted HTML.
 * @param {object} [options] - Extra DOMPurify config (e.g. `{ ADD_ATTR: [...] }`).
 * @returns {string} Safe HTML.
 */
export function sanitizeHtml(dirty, options = {}) {
    if (dirty == null) return '';
    return DOMPurify.sanitize(String(dirty), options);
}

export default sanitizeHtml;
